import {Player} from '@wix/music-player';
import {merge, NEVER, Observable, of} from 'rxjs';
import {filter, mergeMap, skip, switchMap, tap, withLatestFrom} from 'rxjs/operators';
import {debug} from '../../utils/debug';
import {pubSub} from './pubSub';
import {viewMode$} from './viewMode';
import {pageNavigation$} from './wixSdkObservables';

export function playPauseObserver(player$: Observable<Player>) {
  const stopPlaying$ = pageNavigation$.pipe(
    withLatestFrom(player$),
    mergeMap(([event, player]) => (event.wasAppOnPage ? of(player.isPlaying) : NEVER)),
  );

  const viewModeChange$ = viewMode$.pipe(
    skip(1),
    switchMap(() => player$),
    filter((player) => player.isPlaying),
  );

  const otherPlayerPlaying$ = pubSub('playing', false).pipe(
    debug('playPause', 'playing'),
    withLatestFrom(player$),
    tap(([_, player]) => player.pause()),
  );

  const startPlaying$ = pageNavigation$.pipe(
    withLatestFrom(stopPlaying$),
    mergeMap(([event, wasPlaying]) => (event.isAppOnPage && wasPlaying ? of(true) : of())),
  );

  return merge(
    merge(viewModeChange$, stopPlaying$, otherPlayerPlaying$).pipe(
      debug('playPause', 'pause'),
      withLatestFrom(player$),
      tap(([_, player]) => player.pause()),
    ),
    startPlaying$.pipe(
      debug('playPause', 'play'),
      withLatestFrom(player$),
      tap(([_, player]) => player.play()),
    ),
  );
}
